jQuery(function($){
  if($('.tooltip').length>0){
    new jBox('Tooltip', {
    attach: '.tooltip',
      maxWidth: 300,
      theme: 'TooltipDark'
  });
  }

  if($('.tooltip-html').length>0){
    new jBox('Tooltip', {
    attach: '.tooltip-html',
      maxWidth: 500,
      isolateScroll: true,
      getTitle: 'data-title',
      getContent: 'data-content',
      theme: 'TooltipDark'
  });
  }

    if($('#jw_chat').length>0){
    $("#jw_chat").click(function(event) {
        event.preventDefault(); // Prevents default behavior of the <a> tag
        //$("#chat-button").trigger("click");
        //console.log();
      GorgiasChat.open();
      });
   }
  
    if($('.jw_home_logo_main_carousel').length>0){
      $('.jw_home_logo_main_carousel').slick({
        centerPadding: '60px',
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,   
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              centerPadding: '40px',
              slidesToShow: 6
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4
            }
          },
           {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });
   }


  if($('#jw_pregnacy_due_date_target').length >0){
     // Initialize datepicker
        $("#jw_pregnacy_due_date_target #lastPeriod").datepicker({
            dateFormat: 'dd/mm/yy',
            changeMonth: true,
            changeYear: true,
            onSelect: function(){
              $("#jw_pregnacy_due_date_target #result").html("");
            }
        });

        $("#jw_pregnacy_due_date_target #calculateBtn").click(function () {
            var lastPeriod = $("#lastPeriod").val();
            var dueDate = calculateDueDate(lastPeriod);
            $("#jw_pregnacy_due_date_target #result").html("<strong>Your due date is:</strong> " + dueDate);
        });

        function calculateDueDate(lastPeriod) {
            // Assuming a gestation period of 280 days (40 weeks)
            var gestationPeriod = 280;
            var lastPeriodDate = $.datepicker.parseDate('dd/mm/yy', lastPeriod);
            var dueDate = new Date(lastPeriodDate.getTime() + gestationPeriod * 24 * 60 * 60 * 1000);

            // Format the due date
            var options = { year: 'numeric', month: 'long', day: 'numeric' };
            return dueDate.toLocaleDateString('en-US', options);
        }
  }

 if($('#jw_ovulation_date_target').length >0){
    // Initialize datepicker
        $("#jw_ovulation_date_target .datepicker").datepicker({
            dateFormat: 'dd/mm/yy',
            changeMonth: true,
            changeYear: true,
            onSelect: function(){
              $("#jw_ovulation_date_target #result").html("");
            }
        });

         // Handle button click
        $("#calculateBtn").click(function () {
            var firstDayOfLastPeriod = $("#jw_ovulation_date_target #firstDayOfLastPeriod").val();
            var cycleLength = $("#jw_ovulation_date_target #cycleLength").val();
            var resultSection = $("#jw_ovulation_date_target #result");

            // Clear previous results
            resultSection.empty();

            // Validate input
            if (!firstDayOfLastPeriod || !cycleLength) {
                resultSection.html("Please enter both the first day of the last period and the average cycle length.");
                return;
            }

            // Parse input values
            var lastPeriodDate = $.datepicker.parseDate('dd/mm/yy', firstDayOfLastPeriod);
            if (!lastPeriodDate) {
                resultSection.html("Invalid date format for the first day of the last period.");
                return;
            }

            // Calculate ovulation date
            var ovulationDate = new Date(lastPeriodDate.getTime() + (cycleLength - 14) * 24 * 60 * 60 * 1000);

            // Format the ovulation date
            var options = { year: 'numeric', month: 'long', day: 'numeric' };
            var formattedDate = ovulationDate.toLocaleDateString('en-US', options);

            // Display result
            resultSection.html("<strong>Estimated Ovulation Date:</strong> " + formattedDate);
        });
    
 }

   if($('#jw_recipes_section').length >0){
     $('.popup-video').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,

		fixedContentPos: false
	});
   }

  });

// === Smooth scroll to in-page anchors (e.g. mega-menu AWARDS -> /#awards) ===
// Works for same-page clicks and cross-page landings (/#awards from another page).
// Offsets the sticky header so the target heading isn't hidden underneath it.
jQuery(function ($) {
  // Bail out completely unless this page has at least one of our anchors.
  if (!$('.jw-scroll-anchor').length) return;

  function headerOffset() {
    var $bar = $('.m-header__wrapper').first();
    if (!$bar.length) { $bar = $('.m-header').first(); }
    return ($bar.length ? $bar.outerHeight() : 0) + 20;
  }

  // Resolve an href's hash to a target element, but ONLY if it is one of ours.
  function anchorFor(href) {
    if (!href) return null;
    var i = href.indexOf('#');
    if (i < 0) return null;
    var id = href.slice(i + 1);
    if (!id) return null;
    var el;
    try {
      el = document.getElementById(decodeURIComponent(id));
    } catch (e) {
      return null;
    }
    if (!el || !el.classList.contains('jw-scroll-anchor')) return null;
    return el;
  }

  function scrollToEl(el) {
    var top = Math.max($(el).offset().top - headerOffset(), 0);
    $('html, body').stop().animate({ scrollTop: top }, 500);
  }

  // Bind ONLY to the specific links that point at our anchors on this same page.
  // No global click delegation, so other links/handlers are never touched.
  $('a[href*="#"]').each(function () {
    var a = this;
    // Same-page only: ignore links that navigate elsewhere.
    if (a.pathname !== window.location.pathname || a.search !== window.location.search) return;
    var el = anchorFor(a.getAttribute('href'));
    if (!el) return;
    $(a).on('click.jwScrollAnchor', function (e) {
      e.preventDefault();
      // Force-close the desktop mega menu: the theme only removes the open
      // state on mouseleave, so after clicking it would otherwise stay open.
      $(this).closest('.m-menu__item').removeClass('m-menu__item--active');
      $('.m-mega-active').removeClass('m-mega-active');
      this.blur();
      scrollToEl(el);
      if (history.pushState) history.pushState(null, '', '#' + el.id);
    });
  });

  // Cross-page landing: arrive on /#awards from another page.
  $(window).on('load', function () {
    var el = anchorFor(window.location.hash);
    if (el) {
      setTimeout(function () { scrollToEl(el); }, 300);
    }
  });
});

// === Image-card text: equalise first-line position (.jw-cards-top) ===
// In a .jw-cards-top Custom content section the card text is bottom-anchored
// (CSS), so different text lengths leave the first lines at different heights.
// Set every card's text block to the tallest one's height (per visual row) so
// the first lines line up. Mobile (<768px) is left alone — text stacks there.
jQuery(function ($) {
  var $inners = $('.jw-cards-top .m-image-card__content-inner');
  if (!$inners.length) return;

  function equalise() {
    $inners.css('min-height', '');           // reset to natural height first
    if (window.innerWidth < 768) return;      // desktop only

    // Group cards by their row (same vertical position), then match heights.
    var rows = {};
    $inners.each(function () {
      var top = Math.round($(this).closest('.m-custom-content__block').offset().top);
      (rows[top] = rows[top] || []).push(this);
    });
    $.each(rows, function (_, els) {
      var max = 0;
      els.forEach(function (el) { max = Math.max(max, $(el).outerHeight()); });
      $(els).css('min-height', max + 'px');
    });
  }

  var t;
  $(window).on('load resize', function () {
    clearTimeout(t);
    t = setTimeout(equalise, 100);
  });
  equalise();
});